import React from "react";

const LoadingBilling = () => {
    return (
        <div className="ticket_loading">
            <div className="card_loading fade-in"></div>
            {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="ticket_loading_row fade-in"></div>
            ))}
        </div>
    )
}

export default LoadingBilling